import React, { Suspense } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { LinearProgress } from '@material-ui/core';

import styles from './styles';

// import TopBar from './TopBar';

function Auth({ route }) {
  const classes = styles();

  return (
    <>
      {/* <TopBar /> */}
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </>
  );
}

Auth.propTypes = {
  route: PropTypes.shape({}),
};

Auth.defaultProps = {
  route: {},
};

export default Auth;
